<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<v-card>
		<v-card-title class="mt-3">
			<h1 class="ml-2">Kwoty</h1>
		</v-card-title>
		<v-layout row>
			<v-flex xs9 mb-5>
				<v-layout align-center justify-center>
					<v-flex xs4/>
					<v-flex xs4 v-if="agencyCurrency.code !== 'PLN'">
						<v-container fluid>
							<v-layout align-center justify-center>
								<strong style="font-size: 15px; text-align: center">
									{{ "Aktualny kurs" }} <span v-if="agencyCurrency.exchangeDate"><br/></span>
									{{ (agencyCurrency.exchangeDate ? "z dnia " + agencyCurrency.exchangeDate : "") }}
									<br/>
									{{ "(1 " + agencyCurrency.code + " = " +
										formatWithoutFixed(agencyCurrency.exchangeRate) + " PLN)" }}
								</strong>
							</v-layout>
						</v-container>
					</v-flex>
					<v-flex xs4>
						<v-container fluid>
							<v-layout align-center justify-center>
								<strong style="font-size: 15px; text-align: center">
									{{ "Kurs referencyjny" }} <span v-if="ownCurrency.exchangeDate"><br/></span>
									{{ (ownCurrency.exchangeDate ? "z dnia " + ownCurrency.exchangeDate : "") }} <br/>
									{{ "(1 " + ownCurrency.code + " = " + formatWithoutFixed(ownCurrency.exchangeRate) +
										" PLN)" }}
								</strong>
							</v-layout>
						</v-container>
					</v-flex>
				</v-layout>
				<v-layout>
					<v-flex xs4>
						<ul class="ml-3">
							<li>
								<div>
									<strong style="font-size: 16px;">Kwota wnioskowana:</strong>
									<span v-if="!amounts.requestedDonation"
										class="ml-3" style="font-size: 16px;">brak</span>
									<span v-else>
										<span class="ml-3" style="font-size: 16px;">
											{{formatMoney(amounts.requestedDonation) + " " + agencyCurrency.code}}
										</span>
									</span>
								</div>
							</li>
						</ul>
					</v-flex>
					<v-flex xs4 v-if="agencyCurrency.code !== 'PLN'">
						<v-layout align-center justify-center style="font-size: 16px;">
							{{ agencyCurrencyAmounts.requestedDonation }}
						</v-layout>
					</v-flex>
					<v-flex xs4>
						<v-layout align-center justify-center style="font-size: 16px;">
							{{ ownCurrencyAmounts.requestedDonation }}
						</v-layout>
					</v-flex>
				</v-layout>
				<v-layout mt-2>
					<v-flex xs4>
						<ul class="ml-3">
							<li>
								<div>
									<strong style="font-size: 16px;">Kwota przyznana:</strong>
									<span v-if="!amounts.summaryDonation"
										class="ml-3" style="font-size: 16px;">brak</span>
									<span v-else>
										<span class="ml-3" style="font-size: 16px;">
											{{formatMoney(amounts.summaryDonation) + " " + agencyCurrency.code}}
										</span>
									</span>
									<span v-if="hasAgencyProjectPanelSupervisorModificationAccess">
										<v-icon style="font-size: 20px" small class="ml-2"
											@click="editSummaryDonation" title="Edytuj">
											edit
										</v-icon>
									</span>
								</div>
							</li>
						</ul>
					</v-flex>
					<v-flex xs4 v-if="agencyCurrency.code !== 'PLN'">
						<v-layout align-center justify-center style="font-size: 16px;">
							{{ agencyCurrencyAmounts.summaryDonation }}
						</v-layout>
					</v-flex>
					<v-flex xs4>
						<v-layout align-center justify-center style="font-size: 16px;">
							{{ ownCurrencyAmounts.summaryDonation }}
						</v-layout>
					</v-flex>
				</v-layout>
				<v-layout mt-2>
					<v-flex xs4>
						<ul class="ml-3">
							<li>
								<div>
									<strong style="font-size: 16px;">Kwota zatwierdzona:</strong>
									<span v-if="!amounts.approvedDonation"
										class="ml-3" style="font-size: 16px;">brak</span>
									<span v-else>
										<span class="ml-3" style="font-size: 16px;">
											{{formatMoney(amounts.approvedDonation) + " " + agencyCurrency.code}}
										</span>
									</span>
								</div>
							</li>
						</ul>
					</v-flex>
					<v-flex xs4 v-if="agencyCurrency.code !== 'PLN'">
						<v-layout align-center justify-center style="font-size: 16px;">
							{{ agencyCurrencyAmounts.approvedDonation }}
						</v-layout>
					</v-flex>
					<v-flex xs4>
						<v-layout align-center justify-center style="font-size: 16px;">
							{{ ownCurrencyAmounts.approvedDonation }}
						</v-layout>
					</v-flex>
				</v-layout>

			</v-flex>
			<v-flex xs3>
				<v-container fluid style="padding: 15px 15% 15px 15%">
					<v-layout align-center justify-center>
						<v-btn block color="accent" dark @click="openNewCurrencyDialog">
							Dodaj kurs referencyjny
						</v-btn>
					</v-layout>
					<v-layout align-center justify-center>
						<v-btn block color="accent" dark @click="recalculate">
							Przelicz
						</v-btn>
					</v-layout>
					<v-layout align-center justify-center>
						<v-btn block color="accent" dark @click="reset">
							Resetuj
						</v-btn>
					</v-layout>
				</v-container>
			</v-flex>
		</v-layout>
		<v-container fluid>
		<v-layout><h3>Uwagi</h3></v-layout>
			<v-layout>
				<v-flex>
					<v-textarea outline auto-grow v-model="project.amountRemarks"
						browser-autocomplete="off" aria-label="amount remarks"></v-textarea>
				</v-flex>
			</v-layout>
			<v-btn primary @click="saveAgencyProjectAmountRemarks">Zapisz</v-btn>
		</v-container>
		<v-dialog v-model="summaryDonationDialog" max-width="600px">
			<v-card>
				<v-card-title>
					<span class="headline"> Edycja kwoty przyznanej </span>
				</v-card-title>

				<v-card-text>
					<v-container grid-list-md>
						<v-flex>
							<egranty-number-input-field
								label="Nowa kwota przyznana"
								v-model="editedDonation"
								:suffix="' ' + agencyCurrency.code"
								placeholder="np. 100000"
							>
							</egranty-number-input-field>
						</v-flex>
					</v-container>
				</v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary" flat @click="summaryDonationDialog = false">Anuluj</v-btn>
					<v-btn color="primary" flat @click="saveSummaryDonation">Zapisz</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog v-model="ownCurrencyDialog" max-width="600px">
			<v-card>
				<v-card-title>
					<span class="headline">Kurs referencyjny</span>
				</v-card-title>

				<v-card-text>
					<v-container grid-list-md>
						<v-layout>
							<egranty-number-input-field
								name="exchangeRate"
								v-model="editedCurrency.exchangeRate"
								label="Wartość w PLN"
								for="currencies-view-valuePLN"
								id="currencies-view-valuePLN"
								:rules="exchangeRateRules"
								suffix=" PLN"
								:fractional-len="5"
							></egranty-number-input-field>
						</v-layout>
						<v-layout>
							<v-menu
								v-model="exchangeDateMenu"
								:close-on-content-click="false"
								:nudge-right="40"
								lazy
								transition="scale-transition"
								offset-y
								full-width
								min-width="290px"
							>
								<template v-slot:activator="{ on }">
									<v-text-field
										v-model="editedCurrency.exchangeDate"
										aria-label="exchange date"
										label="Data kursu"
										prepend-icon="event"
										browser-autocomplete="off"
										for="exchange-date"
										id="exchange-date"
										readonly
										v-on="on"
									></v-text-field>
								</template>
								<v-date-picker no-title :first-day-of-week="1" scrollable locale="pl-PL"
									v-model="editedCurrency.exchangeDate" @input="exchangeDateMenu = false"/>
							</v-menu>
						</v-layout>
					</v-container>
				</v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary" flat @click="ownCurrencyDialog = false">Anuluj</v-btn>
					<v-btn color="primary" flat @click="saveOwnCurrency"
						v-if="editedCurrency.exchangeRate && editedCurrency.exchangeDate">Zapisz
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-card>
</template>

<script>
	import {AgencyProject} from "../../../api/generated/AgencyProject";
	import {Numbers} from "../../../utils/Numbers";
	import EgrantyNumberInputField from "../../../genericComponents/EgrantyNumberInputField";

	export default {
		name: "AgencyProjectAmountsView",
		components: {EgrantyNumberInputField},
		mixins: [
			Numbers,
		],

		mounted () {
			this.getCurrency();
			this.getSupervisorStatus();
		},
		props: {
			project: {
				type: Object
			},
		},
		data () {
			return {
				agencyCurrency: {
					code: "",
					exchangeRate: null,
					exchangeDate: undefined,
				},
				ownCurrency: {
					code: "",
					exchangeRate: null,
					exchangeDate: undefined
				},
				editedCurrency: {
					exchangeRate: null,
					exchangeDate: undefined
				},
				amounts: {},
				agencyCurrencyAmounts: {
					requestedDonation: null,
					summaryDonation: null,
					approvedDonation: null
				},
				ownCurrencyAmounts: {
					requestedDonation: null,
					summaryDonation: null,
					approvedDonation: null
				},
				summaryDonationDialog: false,
				ownCurrencyDialog: false,
				editedDonation: null,
				exchangeRateRules: [
					v => !!v || "Podanie wartości w PLN jest obowiązkowe",
				],
				exchangeDateMenu: false,
				isSupervisor: false
			};
		},

		computed: {
			hasAgencyProjectPanelSupervisorModificationAccess(){
				return this.$store.state.agencyProjectPanelPermissions.hasAgencyProjectPanelSupervisorModificationAccess;
			},
		},

		methods: {
			getCurrency () {
				AgencyProject.getCurrencyCode(this, this.$route.params.projectId, successResponse => {
						this.agencyCurrency = successResponse;
						this.ownCurrency.code = this.agencyCurrency.code;
						this.getProjectAmounts();
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się załadować waluty", errorResponse);
					});
			},

			getSupervisorStatus () {
				AgencyProject.getIsSupervisor(this, this.$route.params.projectId, successResponse => {
						this.isSupervisor = successResponse;
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się załadować statusu użytkownika", errorResponse);
					});
			},

			getProjectAmounts () {
				AgencyProject.getAmounts(this, this.$route.params.projectId, successResponse => {
						this.amounts = successResponse;
						if (successResponse.hasOwnCurrency) {
							this.ownCurrency.exchangeDate = successResponse.exchangeDate;
							this.ownCurrency.exchangeRate = successResponse.exchangeRate;
							this.editedCurrency.exchangeDate = successResponse.exchangeDate;
							this.editedCurrency.exchangeRate = successResponse.exchangeRate;
						}
						this.recalculate();
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się załadować kwot", errorResponse);
					});
			},

			editSummaryDonation () {
				this.editedDonation = this.amounts.summaryDonation;
				this.summaryDonationDialog = true;
			},

			openNewCurrencyDialog () {
				this.ownCurrencyDialog = true;
			},

			recalculate () {
				let agencyRate = this.agencyCurrency.exchangeRate;
				let ownRate = this.ownCurrency.exchangeRate;
				this.agencyCurrencyAmounts.requestedDonation = Numbers.methods.formatMoney(this.amounts.requestedDonation * agencyRate) + " PLN";
				this.agencyCurrencyAmounts.summaryDonation = Numbers.methods.formatMoney(this.amounts.summaryDonation * agencyRate) + " PLN";
				this.agencyCurrencyAmounts.approvedDonation = Numbers.methods.formatMoney(this.amounts.approvedDonation * agencyRate) + " PLN";
				this.ownCurrencyAmounts.requestedDonation = Numbers.methods.formatMoney(this.amounts.requestedDonation * ownRate) + " PLN";
				this.ownCurrencyAmounts.summaryDonation = Numbers.methods.formatMoney(this.amounts.summaryDonation * ownRate) + " PLN";
				this.ownCurrencyAmounts.approvedDonation = Numbers.methods.formatMoney(this.amounts.approvedDonation * ownRate) + " PLN";
			},

			reset () {
				this.editedCurrency.exchangeDate = null;
				this.editedCurrency.exchangeRate = null;
				AgencyProject.putOwnCurrency(this, this.$route.params.projectId, this.editedCurrency, successResponse => {
						this.ownCurrency.exchangeDate = this.editedCurrency.exchangeDate;
						this.ownCurrency.exchangeRate = this.editedCurrency.exchangeRate;
						this.recalculate();
						this.$messagesBus.$emit("success", "Kurs został pomyślnie zresetowany", successResponse);
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się zresetować kursu", errorResponse);
					});
			},
			saveOwnCurrency () {
				AgencyProject.putOwnCurrency(this, this.$route.params.projectId, this.editedCurrency, successResponse => {
						this.ownCurrency.exchangeDate = this.editedCurrency.exchangeDate;
						this.ownCurrency.exchangeRate = this.editedCurrency.exchangeRate;
						this.ownCurrencyDialog = false;
						this.$messagesBus.$emit("success", "Kurs został pomyślnie zapisany", successResponse);
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się zapisać kursu", errorResponse);
					});
			},

			saveSummaryDonation () {
				AgencyProject.putSummaryDonation(this, this.$route.params.projectId, {body: this.editedDonation}, successResponse => {
						this.amounts.summaryDonation = this.editedDonation;
						this.editedDonation = null;
						this.summaryDonationDialog = false;
						this.$messagesBus.$emit("success", "Kwota została pomyślnie zmieniona", successResponse);
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się zapisać kwoty", errorResponse);
					});
			},
			saveAgencyProjectAmountRemarks() {
				AgencyProject.putAmountRemarks(this, this.$route.params.projectId, {body: this.project.amountRemarks});
			}
		},
	};
</script>

<style scoped>

</style>